<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },

    labels: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ''
    }
  },

    computed:{
      ifDefaultTheme(){
        return  process.env.VUE_APP_THEME == 0
      },
          
      chartOptions() {
        if (this.ifDefaultTheme) {
          return {

            chart: {
              type: 'donut',
            },
            responsive: [{
              breakpoint: 480,
              options: {
                chart: {
                  width: 260,
                },
                legend: {
                  position: 'bottom'
                }
              }
            }],
            labels: this.labels,
            title: {
              text: this.title,
              align: 'left',
              margin: 40,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: {
                fontSize: '16px',
                color: '#263238'
              },
            },
          
          };
        } else {
          return {
          chart: {
              type: 'donut',
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 260,
                  },
                  legend: {
                    position: 'bottom'
                  }
                }
              }
            ],
            labels: this.labels,
            colors: ['#27AE60', '#4f81bd2e'],
            dataLabels: {
              enabled: true,
              style: {
                fontSize: '14px',
                fontWeight: 'bold',
                colors: ['#000'],
              },
              formatter: function (val, opts) {
                const label = opts.w.globals.labels[opts.seriesIndex].toLowerCase().includes('tel') ? 'TEL' : 'WEB';
                return label + ' (' + Math.round(val) + '%)';
              },

              dropShadow: {
                enabled: true,
                color: 'rgba(0, 0, 0, 0.5)',  
                top: 1,
                left: 1,
                blur: 3,                      
                opacity: 0.7                  
              }

            },

            stroke: {
              show: true,
              width: 6,
              colors: ['#ffffff']
            },

            title: {
              text: this.title,
              align: 'left',
              margin: 40,
              offsetX: 0,
              offsetY: 0,
              floating: false,
              style: {
                fontSize: '16px',
                color: '#263238'
              },
            }


            
          };
        }
      },

    },

      data() {
         return {
          series: this.data,
         }
        }


};
</script>

<template>
  <apexchart
  height="400"
    :type="ifDefaultTheme? 'donut' : 'pie'" 
    :series="series"
    :options="chartOptions"
  ></apexchart> 
</template>
